import React, { type CSSProperties } from 'react';

import { cn } from 'lib/utils';

interface TextLinesShimmerProps extends React.HTMLAttributes<HTMLDivElement> {
  lineCount?: number;
}

const LINE_WIDTHS = ['100%', '100%', '100%', '100%', '100%', '100%'] as const;

const shimmerStyle: CSSProperties = {
  backgroundImage:
    'linear-gradient(90deg, rgba(192,194,198,0.55) 0%, rgba(235,235,237,0.9) 45%, rgba(192,194,198,0.55) 100%)',
  backgroundSize: '200% 100%',
  ['--shimmer-width' as string]: '140px',
};

export const TextLinesShimmer: React.FC<TextLinesShimmerProps> = ({
  className,
  lineCount = 4,
  ...props
}) => {
  const count = Math.max(1, Math.min(lineCount, LINE_WIDTHS.length));

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn('w-full h-full flex flex-col justify-center gap-4', className)}
      {...props}
    >
      {LINE_WIDTHS.slice(0, count).map((width, index) => (
        <div
          key={`${width}-${index}`}
          className="h-3 rounded-lg animate-shimmer"
          style={{ ...shimmerStyle, width }}
        />
      ))}
    </div>
  );
};
